import { Component } from '@angular/core';

@Component({
  selector: 'app-guide-enterprise-analytics',
  templateUrl: './guide-enterprise-analytics.component.html',
  styleUrls: ['./guide-enterprise-analytics.component.scss']
})
export class GuideEnterpriseAnalyticsComponent {

}
